const prependProtocolToURL = (url: string | null | undefined): string => {
  if (!url) {
    return ''
  }
  if (!/http:\/\//.test(url) && !/https:\/\//.test(url)) {
    url = `http://${url}`
  }
  return url
}

export default prependProtocolToURL
